// demo-container — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    border: var(--run-demo-container-border, 1px solid var(--run-color-border-subtle));
    border-radius: var(--run-demo-container-radius, var(--run-radius-semantic-card));
    overflow: hidden;
  }

  .preview-area {
    min-height: 64px;
    padding: var(--run-demo-container-preview-padding, var(--run-space-semantic-md));
    background: var(--run-demo-container-preview-bg-default, var(--run-color-surface-default));
  }

  .preview-area[data-preview-padding="none"] {
    padding: 0;
  }

  .preview-area[data-preview-padding="sm"] {
    padding: var(--run-space-semantic-sm);
  }

  .preview-area[data-preview-padding="md"] {
    padding: var(--run-space-semantic-md);
  }

  .preview-area[data-preview-padding="lg"] {
    padding: var(--run-space-semantic-lg);
  }

  .preview-area[data-background="default"] {
    background: var(--run-demo-container-preview-bg-default, var(--run-color-surface-default));
  }

  .preview-area[data-background="light"] {
    background: var(--run-demo-container-preview-bg-light, #ffffff);
  }

  .preview-area[data-background="dark"] {
    background: var(--run-demo-container-preview-bg-dark, #000000);
  }

  .preview-area[data-background="checkerboard"] {
    background-color: #ffffff;
    background-image: repeating-conic-gradient(
      var(--run-demo-container-checkerboard-color, var(--run-color-surface-subtle)) 0% 25%,
      #ffffff 0% 50%
    );
    background-size: 16px 16px;
  }

  .divider {
    height: 0;
    border-top: var(--run-demo-container-divider, 1px solid var(--run-color-border-subtle));
  }

  .caption-wrapper {
    padding: var(--run-demo-container-preview-padding, var(--run-space-semantic-md));
    color: var(--run-demo-container-caption-color, var(--run-color-text-secondary));
    border-top: var(--run-demo-container-divider, 1px solid var(--run-color-border-subtle));
  }

  run-code-display {
    display: block;
    border-top: var(--run-demo-container-divider, 1px solid var(--run-color-border-subtle));
  }
`;

export function render(host) {
  const { background, previewPadding, caption, _hasCaptionSlot, _captionId } = host;

  const captionActive = (caption && caption.trim() !== '') || _hasCaptionSlot;

  const captionBlock = captionActive ? `
    <div class="caption-wrapper" part="caption" id="${_captionId}">
      <slot name="caption">
        <run-text size="sm" color="subtle">${caption || ''}</run-text>
      </slot>
    </div>
  ` : '';

  host.shadowRoot.innerHTML = `
    <div
      class="preview-area"
      part="preview"
      data-background="${background}"
      data-preview-padding="${previewPadding}"
    >
      <slot></slot>
    </div>
    ${captionBlock}
    <run-code-display></run-code-display>
  `;
}